import pick from 'lodash/pick'

const setProfile = (state, profile) => {
  Object.assign(state, { profile })
}

const updateProfile = (state, data) => {
  state.profile = {
    ...state.profile,
    ...data
  }
}

const setPhotoURL = (state, photo) => {
  Object.assign(state, { photoURL: photo?.url })
}

const setLiteProfile = (state, profile) => {
  const displayName = profile?.socialName || profile?.fullName

  const liteProfile = {
    ...profile,
    displayName
  }

  Object.assign(state, { liteProfile })
}

const updateLiteProfile = (state, profile) => {
  const liteProfileFields = [
    'age',
    'fullName',
    'nickName',
    'sex',
    'socialName',
    'tags',
    'userType'
  ]
  const liteProfileData = pick(profile, liteProfileFields)
  const enrichedData = {
    ...state.liteProfile,
    ...liteProfileData
  }
  setLiteProfile(state, enrichedData)
}

const clearLiteProfile = state => {
  state.liteProfile = {}
}

const clearPhotoUrl = state => {
  state.photoURL = undefined
}

export default {
  setProfile,
  updateProfile,
  setPhotoURL,
  setLiteProfile,
  updateLiteProfile,
  clearLiteProfile,
  clearPhotoUrl
}
